export default "/assets/images/award-img-01.d4dd0b65b23f02c3.png";